module.exports = __webpack_public_path__ + "images/add-button-icon.svg";